import {
  setOtpDataSuccess,
  setOtpDataLoading,
  setOtpDataFail,
} from "store/reducers/Authentication/otp";

export const setOtpData = (token) => async (dispatch) => {
  try {
    dispatch(setOtpDataLoading(true));

    dispatch(setOtpDataSuccess(token));
  } catch (error) {
    dispatch(setOtpDataFail("Failed to set otp!"));
    console.error(error);
  }
};
